import {useState} from "react";
import Modal from "@/components/UI/Modal/Modal";
import styles from "./KeybindsModal.module.scss";
import Icon from "@/components/UI/Icon/Icon";

type Props = {
  open: boolean
  onStateChange: (open: boolean) => void
}

const KeybindsModal = ({onStateChange, open}: Props) => {
  
  const toggleOpen = () => onStateChange(!open)

  return (
    <>
      <button className={styles.button}>
        <span onClick={toggleOpen}><Icon icon="keyboard"/> Keybinds</span>
      </button>
      <Modal open={open} onClose={toggleOpen} blur header="Crossword Keybinds">
        <ul className={styles.keybindsList}>
          <li><strong>Arrow Keys</strong> Move selected cell</li>
          <li><strong>Enter / Tab</strong> Next clue</li>
          <li><strong>Shift + Tab:</strong> Previous clue</li>
          <li><strong>Delete</strong> Clear current cell</li>
          <li><strong>Backspace</strong> Clear current cell and move back</li>
          <li><strong>Space</strong> Toggle across/down</li>
        </ul>
      </Modal>
    </>
  )
}

export default KeybindsModal